<template>
  <v-dialog width="400px" title="Edit User" :visible.sync="dialogVisible" :scrollbar="false" :z-index="2000"
    @opened="onOpened" @closed="onClosed">
    <el-form ref="form" :model="form" :rules="formRules" label-position="top" v-loading="loading"
      element-loading-text="loading...">
      <el-form-item prop="roleID" label="Role">
        <el-select v-model="form.roleID" placeholder="Please select role" @change="onRoleChange"
          :disabled="isSupervisor">
          <el-option v-for="(item, i) in roleList" :key="i" :value="item.RoleID" :label="item.RoleName" />
        </el-select>
      </el-form-item>
      <el-form-item prop="supervisorId" label="Manager" v-if="supervisorVisible">
        <el-select v-model="form.supervisorId" placeholder="Please select manager"
          :disabled="supervisorDisabled || isSupervisor" filterable>
          <el-option v-for="(item, i) in supervisors" :key="i" :value="item.UserID" :label="item.Name" />
        </el-select>
      </el-form-item>
      <el-form-item prop="taId" :label="taLabel" v-if="taVisible">
        <el-select v-model="form.taId" :placeholder="taMessage" filterable :disabled="isSupervisor">
          <el-option v-for="(item, i) in taList" :key="i" :value="item.TAID" :label="item.TAName" />
        </el-select>
      </el-form-item>
      <el-form-item prop="teamName" label="Team" v-if="teamNameVisible">
        <el-input v-model="form.teamName" placeholder="Please input team name" autocomplete="off" maxlength="50"
          :disabled="isSupervisor" />
      </el-form-item>
      <el-form-item prop="name" label="Name">
        <el-input v-model="form.name" placeholder="Please input name" maxlength="20" autocomplete="off"
          :disabled="isSupervisor" />
      </el-form-item>
      <el-form-item prop="loginName" label="LoginName">
        <el-input v-model="form.loginName" placeholder="Please input login Name" maxlength="25" :disabled="isSupervisor"
          @input="onLoginNameInput" autocomplete="off" />
      </el-form-item>
      <el-form-item prop="email" label="Email">
        <el-input v-model.trim="form.email" placeholder="Please input email" autocomplete="off"
          :disabled="isSupervisor" />
      </el-form-item>
      <el-form-item prop="phone" label="Phone">
        <el-input v-model="form.phone" placeholder="Please input phone" maxlength="20" @input="onPhoneInput"
          :disabled="isSupervisor" autocomplete="off" />
      </el-form-item>
      <el-form-item prop="taConfigId" label="TA" v-if="showTA">
        <el-select v-model="form.taConfigId" placeholder="Please select TA" filterable @change="noMatch = false">
          <el-option v-for="item in taConfitList" :key="item.taConfigId" :label="item.taConfigName"
            :value="item.taConfigId" />
        </el-select>
      </el-form-item>
    </el-form>
    <div class="actions">
      <el-button type="primary" @click="onConfirm" :loading="submitting">
        Submit{{ submitting ? "ting" : "" }}
      </el-button>
      <el-button @click="onClosed">Cancel</el-button>
    </div>
  </v-dialog>
</template>

<script>
import { trimValidate } from "../../utils/validator";
import { findRoleGroupById, LeaderLabelValues } from "../../utils/role-constant";
import { RoleCode } from '@/utils/role-constant'

export default {
  name: "NewUserDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
  },
  data() {
    const validateEmail = (rule, value, callback) => {
      const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (emailReg.test(value)) {
        callback();
      } else {
        callback(new Error("Email format error, please re-enter"));
      }
    };
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|7|8|9][0-9]{9}$/;
      if (!Number.isInteger(+value)) {
        callback(new Error("Phone format error, please re-ente"));
      } else {
        if (phoneReg.test(value) || this.form.phone == "") {
          callback();
        } else {
          callback(new Error("Phone format error, please re-ente"));
        }
      }
    };
    return {
      dialogVisible: this.visible,
      roleList: [],
      supervisors: [
        {
          UserID: "",
          Name: "NA",
        },
      ],
      taList: [
        {
          TAID: "",
          TAName: "NA",
        },
      ],
      teamNameVisible: false,
      supervisorVisible: true,
      supervisorDisabled: false,
      taVisible: false,
      form: {
        name: "",
        loginName: "",
        email: "",
        roleID: "",
        supervisorId: "",
        phone: "",
        teamName: "",
        taId: "",
        taConfigId: null,
      },
      formRules: {
        name: [
          {
            required: true,
            validator: trimValidate("Please fill in the name"),
            trigger: "blur",
          },
        ],
        loginName: [
          {
            required: true,
            validator: trimValidate("Please fill in the login name"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            validator: validateEmail,
            trigger: "blur",
          },
        ],
        supervisorId: [
          {
            required: true,
            message: "Please select the manager",
            trigger: "change",
          },
        ],
        taId: {
          required: false,
          message: "",
          trigger: "change",
        },
        phone: [{ validator: validatePhone, trigger: "change" }],
        teamName: [
          {
            required: false,
            validator: trimValidate("Please fill in the team name"),
            trigger: "blur",
          },
        ],
        taConfigId: [
          {
            required: false,
            message: "Please select TA",
            trigger: "change",
          },
        ],
      },
      loading: false,
      submitting: false,
      roleId: null,
      taConfitList: [],
      showTA: false,
      noMatch:false
    };
  },
  computed: {
    taLabel() {
      return this.taVisible ? LeaderLabelValues[this.roleId].label : "";
    },
    taMessage() {
      return `Please select ${this.taLabel ? this.taLabel.toLowerCase() : ""}`;
    },
    tips() {
      return "This Team has a Manager, please confirm to replace the Manager."
    },
    isSupervisor() {
      return this.$store.state.role === RoleCode.Supervisor
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    onOpened() {
      this.noMatch = false
      this.loading = true;
      this.$axios
        .all([
          this.axios.get("/user/roleList"),
          this.axios.get("/user/svList"),
          this.axios.get("/user/taList/msl"),
          this.axios.get("/user/taConfig"),
        ])
        .then((res) => {
          this.loading = false;
          // roleList
          this.handleRoleListResp(res[0]);
          // svList
          this.handleSupervisorsResp(res[1]);
          // taList
          this.handleTaResp(res[2]);
          //taconfig
          this.getTAList(res[3])

          if (this.data) {
            this.form.name = this.data.Name;
            this.form.loginName = this.data.LoginName;
            this.form.email = this.data.Email;
            this.form.phone = this.data.Phone;
            this.form.teamName = this.data.TeamName ? this.data.TeamName : "";
            this.form.taConfigId = this.noMatch?this.data.TaConfigName:this.data.TaConfigId;
            if (this.data.RoleID === "d3eb0bb1-1752-41aa-8e62-11015ff6b2a2"
                || this.data.RoleID === "abb4cd4c-4a81-4591-9f29-c25f6691a8a9"
                || this.data.RoleID === "75bed9cc-3fc7-4e81-bdfc-962f9d394946"
            ) {
              this.showTA = true
              this.formRules.taConfigId[0].required = true
            }
          }
        });
    },
    getTAList({ code, msg, data }) {
          if (code === 200) {
            this.taConfitList = data
            const duplicateIds = this.taConfitList.filter(item => item.taConfigId === this.data.TaConfigId);
            if (duplicateIds.length == 0 && this.data.TaConfigId) {
              this.noMatch = true
            }
          } else {
            this.$message.error(msg);
          }
    },
    onClosed() {
      this.noMatch = false
      this.roleId = null;
      this.taVisible = false; // MSL Leader
      this.formRules.taId.required = false;
      this.supervisorVisible = true; // Manager
      this.supervisorDisabled = false;
      this.formRules.supervisorId[0].required = true;
      this.teamNameVisible = false; // Team
      this.formRules.teamName[0].required = false;
      this.formRules.taConfigId[0].required = false;
      this.$refs.form.resetFields();
      this.$emit("update:data", null);
      this.$emit("update:visible", false);
    },
    onLoginNameInput(value) {
      this.form.loginName = value.toUpperCase();
    },
    onPhoneInput(value) {
      this.form.phone = value.replace(/\D/g, "");
    },
    onRoleChange(RoleID) {
      if (RoleID) {
        this.showTA = false
        this.formRules.taConfigId[0].required = false
        switch (RoleID) {
          case "75bed9cc-3fc7-4e81-bdfc-962f9d394946": // Supervisor
          case "94a2ff8d-a5f0-405a-abbb-2aee8be126d5": // CRP
          case "a2b2b73d-67ed-4f72-9428-8c791e8432f7": // SciCom
          case "751a30aa-4fea-4388-98d3-778003cb8e71": // CVEO
          case "84e3a762-be15-4c2c-8cfb-5c6aff988ac5": // CT
            this.roleId = RoleID;
            this.taVisible = true; // Show Leader
            this.formRules.taId.required = true;
            this.formRules.taId.message = this.taMessage;
            this.form.taId = "";
            this.$refs.form.clearValidate("taId");
            this.supervisorVisible = false; // Manager
            this.formRules.supervisorId[0].required = false;
            this.form.supervisorId = "";
            this.$refs.form.clearValidate("supervisorId");
            this.formRules.teamName[0].required = true;
            this.teamNameVisible = RoleID === "75bed9cc-3fc7-4e81-bdfc-962f9d394946"; // Team
            if (this.teamNameVisible) {
              this.getTA();
              this.form.taConfigId = "";
              this.$refs.form.clearValidate("taConfigId");
              this.showTA = true;
              this.formRules.taConfigId[0].required = true;
            } else {
              this.getTA(`/user/taList/${LeaderLabelValues[RoleID].value}`);
            }
            break;
          case "0cb6ab37-2ab0-4123-80bd-c3e1f12adc32": // CRP Leader
          case "dd9472ff-e3a6-42da-b8bb-7796e026d82a": // SciCom Leader
          case "ece81c6e-aae5-45c2-8bdb-bf86e3c40e1f": // CVEO Leader
          case "1bb1860e-5dea-4568-bd42-e64bee93081b": // CT Leader
            this.taVisible = false; // Show Leader
            this.formRules.taId.required = true;
            this.formRules.taId.message = this.taMessage;
            this.form.taId = "";
            this.$refs.form.clearValidate("taId");
            this.supervisorVisible = false; // Manager
            this.formRules.supervisorId[0].required = false;
            this.form.supervisorId = "";
            this.$refs.form.clearValidate("supervisorId");
            this.teamNameVisible = true; // Team
            this.formRules.teamName[0].required = true;
            this.$refs.form.clearValidate("teamName");
            break;
          
          // MSL Leader
          case "3ddd8bc6-c5ac-432d-ab0b-05d0e59d5d6e":
          // case "522d6b01-4ad8-4222-865d-20dc67460898"://call-center
            this.taVisible = false; // MSL Leader
            this.formRules.taId.required = false;
            this.form.taId = "";
            this.$refs.form.clearValidate("taId");
            this.supervisorVisible = false; // Manager
            this.formRules.supervisorId[0].required = false;
            this.form.supervisorId = "";
            this.$refs.form.clearValidate("supervisorId");
            this.teamNameVisible = false; // Team
            this.formRules.teamName[0].required = false;
            this.form.teamName = "";
            this.$refs.form.clearValidate("teamName");
            break;
          // Admin
          case "d271d4c8-cc66-4327-8911-47ba35dc57df":
            this.taVisible = false; // MSL Leader
            this.formRules.taId.required = false;
            this.form.taId = "";
            this.$refs.form.clearValidate("taId");
            this.supervisorVisible = true; // Manager
            this.supervisorDisabled = true;
            this.formRules.supervisorId[0].required = false;
            this.form.supervisorId = "";
            this.$refs.form.clearValidate("supervisorId");
            this.teamNameVisible = false; // Team
            this.formRules.teamName[0].required = false;
            this.form.teamName = "";
            this.$refs.form.clearValidate("teamName");
            break;
          // MSL
          case "d3eb0bb1-1752-41aa-8e62-11015ff6b2a2":
          case "abb4cd4c-4a81-4591-9f29-c25f6691a8a9": //vMSL
          case "522d6b01-4ad8-4222-865d-20dc67460898"://call-center
            this.taVisible = false; // MSL Leader
            this.formRules.taId.required = false;
            this.form.taId = "";
            this.$refs.form.clearValidate("taId");
            this.supervisorVisible = true; // Manager
            this.supervisorDisabled = false;
            this.formRules.supervisorId[0].required = true;
            this.teamNameVisible = false; // Team
            this.formRules.teamName[0].required = false;
            this.form.teamName = "";
            this.$refs.form.clearValidate("teamName");
            this.form.taConfigId = "";
            this.$refs.form.clearValidate("taConfigId");
            this.getTA();
            this.showTA = true
            this.formRules.taConfigId[0].required = RoleID !== "522d6b01-4ad8-4222-865d-20dc67460898"
            break;
        }
      }
    },
    handleRoleListResp({ code, data, msg }) {
      if (code === 200) {
        this.roleList = findRoleGroupById(this.data.RoleID, data);
        if (this.data && !this.data.RoleID && data && data.length > 0) {
          this.form.roleID = data[0].RoleID;
        } else {
          this.form.roleID = this.data.RoleID;
        }
        this.onRoleChange(this.form.roleID);
      } else {
        this.$message.error(msg);
      }
    },
    handleSupervisorsResp({ code, data, msg }) {
      if (code === 200) {
        this.supervisors = [
          {
            UserID: "",
            Name: "NA",
          },
        ].concat(data);
        if (this.data && this.data.UserID) {
          let ret = this.supervisors.find((x) => {
            return x.UserID == this.data.UserID;
          });
          if (ret) {
            this.supervisors.splice(this.supervisors.indexOf(ret), 1);
          }
        }
        if (this.data && this.data.SupervisorID) {
          if (
            !this.supervisors.find((x) => {
              return this.data.SupervisorID == x.UserID;
            })
          ) {
            this.form.supervisorId = "";
          } else {
            this.form.supervisorId = this.data.SupervisorID;
          }
        }
      } else {
        this.$message.error(msg);
      }
    },
    handleTaResp({ code, data, msg }) {
      if (code === 200) {
        this.taList = [
          {
            TAID: "",
            TAName: "NA",
          },
        ].concat(data);
        if (this.data && this.data.UserID) {
          let ret = this.taList.find((x) => {
            return x.TAID == this.data.UserID;
          });
          if (ret) {
            this.taList.splice(this.taList.indexOf(ret), 1);
          }
        }
        if (this.data && this.data.TAID) {
          if (
            !this.taList.find((x) => {
              return this.data.TAID == x.TAID;
            })
          ) {
            this.form.taId = "";
          } else {
            this.form.taId = this.data.TAID;
          }
        }
      } else {
        this.$message.error(msg);
      }
    },
    getTA(url = "/user/taList/msl") {
      this.axios.get(url).then(this.handleTaResp);
    },
    checkTeamExist() {
      this.submitting = true;
      this.axios.get("/user/checkTeamExist", {
        params: {
          roleId: this.form.roleID,
          teamName: this.form.teamName.trim(),
          userId: this.form.roleID === this.data.RoleID ? this.data.UserID : ""
        }
      }).then(({ code, data }) => {
        if (200 === code) {
          if (data) {
            this.$confirm(this.tips, {
              confirmButtonText: "Confirm",
              cancelButtonText: "Cancel",
              type: "warning"
            }).then(() => {
              this.submitRequest();
            }).catch(() => {
              this.submitting = false;
            });
          } else {
            this.submitRequest();
          }
        } else {
          this.$message.error("Checking team exist failure.");
          this.submitting = false;
        }
      }).catch(() => {
        this.submitting = false;
      });
    },
    submitRequest() {
      this.submitting = true;
      this.axios
        .post("/user/update", {
          name: this.form.name.trim(),
          loginName: this.form.loginName.trim(),
          email: this.form.email.trim(),
          roleID: this.form.roleID,
          supervisorId: this.form.supervisorId,
          phone: this.form.phone.trim(),
          teamName: this.form.teamName.trim(),
          teamID: this.data.TeamID,
          taId: this.form.taId,
          userID: this.data.UserID,
          taConfigId: (this.noMatch?this.data.TaConfigId:this.form.taConfigId)||null,
        })
        .then(({ code, msg }) => {
          if (code === 200) {
            this.$emit("success");
            this.$message.success("Update user successfully");
            this.onClosed();
          } else {
            this.$message.error(msg);
          }
          this.submitting = false;
        })
        .catch(() => {
          this.submitting = false;
        });
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$confirm(
          "Please make sure if it is ready to submit?",
          "Attention",
          {
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
          }
        ).then(() => {
          if (this.teamNameVisible) {
            this.checkTeamExist();
          } else {
            this.submitRequest();
          }
        }).catch(() => {
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form {
  .el-form-item {
    margin-bottom: 10px;
  }

  ::v-deep {
    .el-form-item__label {
      padding: 0 !important;
    }
  }

  .el-input,
  .el-select {
    width: 100%;
  }
}

.actions {
  margin-top: 20px;
  text-align: center;
}

::v-deep {
  .el-dialog__header {
    padding-bottom: 0;
  }

  .el-dialog__body {
    padding: 20px 40px 20px;
  }

  .el-dialog__footer {
    padding: 0;
  }
}
</style>
